export var ExternalUserState;
(function (ExternalUserState) {
    ExternalUserState["PENDING_ACCEPTANCE"] = "PendingAcceptance";
    ExternalUserState["ACCEPTED"] = "Accepted";
})(ExternalUserState || (ExternalUserState = {}));
//# sourceMappingURL=graph-api-data.js.map